import clsx from 'clsx'
import {useState} from 'react'
import AudioManager from '../../../AudioManager'
import {useTracking} from '../../../Tracking/Tracking.hooks'
import VolumeMutedIcon from './volume-muted.svg'
import VolumeOnIcon from './volume-on.svg'

const audio = new AudioManager()

export const VolumeButton = ({isFlipBurgerSettings = false}: {isFlipBurgerSettings?: boolean}) => {
  const {trackEvent} = useTracking()
  const [isMuted, setIsMuted] = useState(audio.getIsMuted())

  return (
    <button
      id="volume-btn"
      className={clsx(
        'settings-button pointer-events-auto',
        'flip-burger-settings-button',
        isFlipBurgerSettings,
      )}
      onClick={() => {
        audio.toggleMute()
        setIsMuted(audio.getIsMuted())

        trackEvent({
          domain: `settings`,
          trigger: 'click',
          source: `audio_${audio.getIsMuted() ? 'mute' : 'unmute'}_button`,
        })
      }}
    >
      <img src={isMuted ? VolumeMutedIcon : VolumeOnIcon} alt="" />
    </button>
  )
}
